"use client"

import { useState } from "react"
import { Home, User, List, Send, Settings, ChevronDown, ChevronRight } from "lucide-react"

export function Sidebar({ activeSection, onSectionChange }) {
  const storedInfo = {
    username: localStorage.getItem('matrimonyUserName') || '',
  };

  const [isProfileManageOpen, setIsProfileManageOpen] = useState(true)
  const [userInfo, setUserInfo] = useState(storedInfo);

  const menuItems = [
    {
      id: "dashboard",
      label: "Dashboard",
      icon: Home,
      isActive: activeSection === "dashboard",
    },
  ]

  const profileManageItems = [
    {
      id: "profile",
      label: "Profile",
      icon: User,
      isActive: activeSection === "profile",
    },
    {
      id: "profile-lists",
      label: "Profile Lists",
      icon: List,
      isActive: activeSection === "profile-lists",
    },
    {
      id: "requests-sent",
      label: "Requests Sent",
      icon: Send,
      isActive: activeSection === "requests-sent",
    },
    {
      id: "profile-listing",
      label: "Profile Listing",
      icon: Settings,
      isActive: activeSection === "profile-listing",
    },
  ]

  return (
    <div className="w-64 bg-white border-r border-gray-200 h-screen">
      <div className="p-6">
        <h2 className="text-xl font-semibold text-gray-800">{userInfo.username}</h2>
      </div>

      <nav className="px-4">
        {/* Dashboard */}
        {menuItems.map((item) => {
          const IconComponent = item.icon
          return (
            <button
              key={item.id}
              onClick={() => onSectionChange(item.id)}
              className={`w-full flex items-center px-4 py-3 text-left rounded-lg mb-1 transition-colors ${item.isActive ? "bg-blue-50 text-blue-600 font-medium" : "text-gray-700 hover:bg-gray-50"
                }`}
            >
              <IconComponent className="w-5 h-5 mr-3" />
              {item.label}
            </button>
          )
        })}

        {/* Profile Manage Section */}
        <div className="mt-4">
          <button
            onClick={() => setIsProfileManageOpen(!isProfileManageOpen)}
            className="w-full flex items-center justify-between px-4 py-3 text-left text-blue-600 font-medium rounded-lg hover:bg-blue-50 transition-colors"
          >
            <div className="flex items-center">
              <User className="w-5 h-5 mr-3" />
              Profile Manage
            </div>
            {isProfileManageOpen ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
          </button>

          {isProfileManageOpen && (
            <div className="ml-8 mt-1">
              {profileManageItems.map((item) => {
                const IconComponent = item.icon
                return (
                  <button
                    key={item.id}
                    onClick={() => onSectionChange(item.id)}
                    className={`w-full flex items-center px-4 py-2 text-left rounded-lg mb-1 transition-colors ${item.isActive ? "bg-blue-50 text-blue-600 font-medium" : "text-gray-600 hover:bg-gray-50"
                      }`}
                  >
                    <IconComponent className="w-4 h-4 mr-3" />
                    {item.label}
                  </button>
                )
              })}
            </div>
          )}
        </div>
      </nav>
    </div>
  )
}
